module.exports = __webpack_public_path__ + "static/media/camion_hidrogeno.6bd7e5b2.png";